<template>
  <label
    :for="attrs.id as string || name"
    class="app--switch relative inline-flex items-center cursor-pointer text-neutral-lighter"
    :class="[attrClass]"
    :style="(attrStyle as StyleValue)"
    @click.stop
  >
    <input
      :id="attrs.id as string || name"
      v-model="checked"
      :name="name"
      type="checkbox"
      class="sr-only peer"
      v-bind="attrs"
    />
    <div
      class="switch-button h-6 w-11 p-1 peer-focus:outline-none peer-focus-visible:ring-2 rounded-full flex after:content-[''] after:rounded-full after:h-4 after:aspect-square transition-colors after:transition-all after:relative peer-checked:after:right-0 peer-checked:after:translate-x-5"
    ></div>
    <span class="ml-3 text-sm font-medium leading-3">
      {{ label }}
    </span>
  </label>
</template>

<script lang="ts">
import type { PropType, StyleValue } from 'vue';
export default {
  inheritAttrs: false
};
</script>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue', 'isValid']);

const props = defineProps({
  modelValue: {
    type: [Boolean, Array] as PropType<boolean | string[]>,
    default: false
  },
  label: {
    type: String,
    default: () => ''
  },
  name: {
    type: String,
    default: () => 'myValue'
  }
});

const { class: attrClass, style: attrStyle, ...attrs } = useAttrs();

const checked = ref(props.modelValue);

watch(
  () => props.modelValue,
  v => {
    checked.value = v;
  }
);

watch(
  () => checked.value,
  v => {
    emit('update:modelValue', v);
  }
);
</script>

<style lang="scss">
.app--switch {
  &.variant-primary,
  &:not([class*='variant-']) {
    & .switch-button {
      @apply bg-neutral-lighter after:bg-white;
    }
    .peer:checked ~ .switch-button {
      @apply bg-primary after:bg-white;
    }
    .peer:focus-visible ~ .switch-button {
      @apply ring-primary/50 ring-2;
    }
  }
  &.variant-white {
    .switch-button {
      @apply shadow-xl bg-black/10 after:bg-white ring-white ring-[3px];
    }
    .peer:checked ~ .switch-button {
      @apply bg-primary-dark after:bg-white;
    }
    .peer:focus-active ~ .switch-button {
      @apply bg-primary-light;
    }
    &:hover .switch-button {
      @apply bg-primary/50;
    }
  }
}
</style>
